<template>
  <v-container fluid class="fill-height pa-1 u_posAbs">
    <v-app-bar rounded="lg" absolute class="ma-1" style="z-index: 2" dense color="primary">
      <!-- <v-app-bar-title class="">Rybářské revíry</v-app-bar-title> -->

      <v-spacer></v-spacer>
      <v-btn icon @click="VybComp = 'MapRyby'" class="ml-8">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>

    <v-card color="transparent" class="fill-height fill-width pt-13 ">
      <v-card rounded="lg" class="fill-height fill-width overflow-auto">

        <v-expansion-panels focusable inset class="" v-model="panel" multiple>
          <v-expansion-panel v-for="(item) in SeznamInfo" :key="item.id">
            <v-expansion-panel-header>
              <div v-html="item.nadpis" class="text-subtitle-1 accent2--text"></div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(item2, index) in item.text" :key="index" v-html="item2" class="ma-3">
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

      </v-card>
    </v-card>
  </v-container>



</template>

<script>

import AppJson from "../assets/InfoRyby.json";

export default {
  props: {
    // Jméno komponenty
    CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },

  data() {
    return {
      // Seznam info
      SeznamInfo: [],

      panel: [0],

    };
  },

  computed: {

    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },


  },


  methods: {

    // Zavře tuto komponentu
    VybCompClose: function () {
      this.$store.commit("SET_sVybComp", {
        CompName: null,
        SlotName: this.CompList.find((item) => item.name == this.CompName).slot,
      });
    },



  },

  watch: {


  },

  mounted() {
    // Vytvoření
    this.SeznamInfo = AppJson.info;

  },
};
</script>

<style>
.InfoTable {
  border-collapse: collapse;
}

.InfoTable th {
  padding-right: 10px;
  padding-left: 10px;
}

.InfoTable td {
  vertical-align: top;
  padding-right: 10px;
  padding-left: 10px;
}
</style>